module.exports = __webpack_public_path__ + "img/vehicle-ape.f5c59727.png";